import { render, staticRenderFns } from "./SHReceiptPopup.vue?vue&type=template&id=b4a07e76&scoped=true"
import script from "./SHReceiptPopup.vue?vue&type=script&lang=ts"
export * from "./SHReceiptPopup.vue?vue&type=script&lang=ts"
import style0 from "./SHReceiptPopup.vue?vue&type=style&index=0&id=b4a07e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a07e76",
  null
  
)

export default component.exports